import styled from 'styled-components';

export const EventsSection = styled.section`
  background: #ebebeb;
  overflow: hidden;
  padding: 50px 0;

  div[class*='SectionHeadlinestyled__SectionHeadline-'] {
    @media (min-width: 575px) {
      margin: 0px;
    }
  }

  .arrow {
    svg {
      width: 0.875rem;
      fill: black;
    }
  }

  &[dir='ltr'] {
    .arrow {
      svg {
        margin-left: 5px;
      }
    }
  }

  &[dir='rtl'] {
    .arrow {
      svg {
        margin-right: 5px;
      }
    }
  }
`;

export const EventsSliderContainer = styled.div`
  padding: 0 50px 40px;

  @media (max-width: 1099px) {
    padding: 30px 0;
  }

  a[class*='EventSliderCardstyled__EventSliderCard-'] {
    margin-bottom: 68px;
  }

  .slick-active {
    a[class*='EventSliderCardstyled__EventSliderCard-'] {
      margin-bottom: 0;
      @media (max-width: 1099px) {
        margin-top: 0px;
      }
    }
  }

  @media (min-width: 578px) {
    .slick-current {
      margin-top: 68px;
    }
  }
`;
